import en from '../../common/en';

const lang: Record<string, string> = {
    ...en,
};

export default lang;
